import React from 'react';
import LegalPage from './LegalPage';

const TermsAndConditionsPage = () => (
  <LegalPage
    title="Terms & Conditions"
    pageTitle="Terms & Conditions"
    documentPath="/legal/terms-and-conditions.md"
  />
);

export default TermsAndConditionsPage;
